import { ListOfEvents } from "../../ListOfEvents/ListOfEvents";
//import "../GuestLectures/GuestLectures.scss";
import guestLectures from "../../../api/guestLectures.json";

export const GuestLectures = () => {
	const lecturesData = guestLectures.map((lecture) => ({
		id: lecture.lectureId,
		year: lecture.lectureYear,
		info: lecture.lectureInfo,
		infoSecond: lecture.lectureInfoSecond,
		infoThird: lecture.lectureInfoThird,
		infoFourth: lecture.lectureInfoFourth,
	}));
	return (
		<section className="container guestLectures">
			<ListOfEvents events={lecturesData} />
		</section>
	);
};
